export function authHeader(token) {
    if (token) {
        return { 'Authorization': token };
    } else {
        return {};
    }
}



// WEBPACK FOOTER //
// ./src/_helpers/auth-header.js